export const recordPerPageWeb = 10;
